/**
 * @file Defines the {@link UI_ORIENTATION_ELEMENTS_INLINE} constant
 * @author Joe Thompson <joe.thompson@1x2network.com>
 */

 /**
  * Elements of UI which need custom styling inline to handle landscape & portrait
  * @type {string[]}
  * @constant
  * @default
  */
 const UI_ORIENTATION_ELEMENTS_INLINE = [

   'menuMobile', 
   'numberInput'

 ]

 export { UI_ORIENTATION_ELEMENTS_INLINE }